import React from 'react';
import moment from 'moment';
import { DatePicker, ConfigProvider, Bubble } from 'tea-component';
import en_US from 'tea-component/es/i18n/locale/en_US';
import zh_CN from 'tea-component/es/i18n/locale/zh_CN';
import './index.scss';

interface IDisabledTimeConfig {
  disabledHours?: () => number[];
  disabledMinutes?: (hour: number) => number[];
  disabledSeconds?: (hour: number, minute: number) => number[];
}

interface ISingleDateTimePickerProps {
  value: string; // 'YYYY-MM-DD HH:mm:ss'
  onChange: (value: string) => void;
  language?: 'cn' | 'en';
  showTime?: boolean; // 是否显示时间选择器
  className?: string;
  disabled?: boolean;
  error?: boolean;
  tips?: string;
  disabledDate?: (date: moment.Moment) => boolean; // 禁用日期函数
  disabledTime?: (date: moment.Moment) => IDisabledTimeConfig; // 禁用时间函数
}

/**
 * 单日期时间选择器组件
 * 使用 tea-component 的 DatePicker，通过 showTime props 控制是否显示时间
 */
const SingleDateTimePicker: React.FC<ISingleDateTimePickerProps> = ({
  value,
  onChange,
  language = 'en',
  showTime = false,
  className = '',
  disabled = false,
  error = false,
  tips = '',
  disabledDate,
  disabledTime,
}) => {
  const locale = language === 'en' ? en_US : zh_CN;
  const currentValue = moment(value);

  // 处理日期（或日期时间）变化
  const handleChange = (newValue: moment.Moment) => {
    if (!newValue?.isValid()) return;

    // 根据 showTime 决定格式
    const format = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss';
    const formattedValue = newValue.format(format);
    onChange(formattedValue);
  };

  return (
    <ConfigProvider locale={locale}>
      <div className={`dbo-single-datetime-picker ${className}`}>
        <Bubble
          visible={error}
          error={true}
          placementOffset={[0, 20]}
          content={tips}
        >
          <DatePicker
            value={currentValue}
            onChange={handleChange}
            disabled={disabled}
            showTime={showTime}
            disabledDate={disabledDate}
            disabledTime={disabledTime}
            className="dbo-single-datetime-picker__picker"
          />
        </Bubble>
      </div>
    </ConfigProvider>
  );
};

export default SingleDateTimePicker;
